module.exports = __webpack_public_path__ + "img/banner8.e579ad35.png";